<template>
  <div class="access-page" v-if="!hideLogin">
    <img src="@/assets/streamify-logotype-blue.svg" class="logotype" />
    <CardMinimal class="access-card">
      <form class="access-form" @keyup.enter.prevent="login" @submit.prevent="login">
        <h1 class="access-title">Login</h1>
        <FormInput
          icon="e-mail-24"
          id="email"
          placeholder="E-mail"
          type="email"
          v-model="email"
          :autocomplete="true"
          :value="email"
          :class="`${error ? 'error' : ''}`"
          @validate="checkEmail"
        />
        <DidYouMean :email="email" @correctEmail="email = $event;" ref="didYouMean" />
        <FormInput
          icon="password-24"
          id="password"
          placeholder="Password"
          type="password"
          v-model="password"
          :value="password"
          :class="`${error ? 'error' : ''}`"
        />
        <div class="d-f ai-c m-t-2 f-wrap" v-if="error">
          <p class="error-text m-r-2">Email and/or password did not match.</p>
          <p class="link blue" @click="resetPassword()">Send password reset link?</p>
        </div>
        <div class="m-t-2" v-else>
          <a href="/resetpassword" class="link blue" @click.prevent="$router.push('/resetpassword')">Have you forgotten your password?</a>
        </div>
        <Button
          class="f-w m-t-4"
          tabindex="0"
          :disabled="!validateInfo || state !== ''"
          :loading="state === 'loggingin'"
          @click.stop="login"
        >
          Login
        </Button>
      </form>
      <div class="line"></div>
      <div class="footer-text">
        <p class="ta-c">Don't have an account? <a :href="`/signup${redirect ? `?redirect=${redirect}` : ''}`" @click.prevent="$router.push(`/signup${redirect ? `?redirect=${redirect}` : ''}`)">Sign up here</a></p>
      </div>
    </CardMinimal>
    <a class="customer-support-link" href="https://support.streamify.io">
      <i class="icon-help"></i> Customer Support
    </a>
  </div>
</template>

<script>

import DidYouMean from '@/components/DidYouMean.vue';

export default {
  components: {
    DidYouMean,
  },
  computed: {
    validateInfo() {
      const {
        email,
        password,
      } = this;
      return email.length !== 0 && password.length !== 0;
    },
  },
  methods: {
    checkEmail() {
      this.$refs.didYouMean.checkEmail();
    },
    async resetPassword() {
      await this.$store.dispatch('User/resetPassword', this.email);
      swal({ title: this.$t('login.password_reset'), text: this.$t('login.password_reset_text') });
    },
    async login() {
      const {
        validateInfo,
        email,
        password,
      } = this;

      this.error = false;
      this.emailError = false;

      if (!validateInfo) {
        return;
      }

      this.state = 'loggingin';

      const user = await this.$store.dispatch('User/login', { email, password });

      if (user) {
        this.hideLogin = true;
        if ([1, 6, 15, 16].indexOf(user.user.permission_id) >= 0) {
          await this.$store.dispatch('AccountManager/getAccountSettings');
          await this.$store.dispatch('AccountManager/getAccount');
          await this.$store.dispatch('AccountManager/getUsers');
          await this.$store.dispatch('AccountManager/getShoppingSettings');
        }
        this.$router.push(decodeURIComponent(this.redirect));
      } else {
        this.error = true;
        this.emailError = true;
        this.state = '';
      }
    },
  },
  data() {
    return {
      email: '',
      password: '',
      error: false,
      emailError: false,
      state: '',
      redirect: '',
      hideLogin: false,
    };
  },
  mounted() {
    if (this.$route.query.redirect) {
      this.redirect = encodeURIComponent(decodeURIComponent(this.$route.query.redirect));
    }
  },
};
</script>

<style lang="scss" scoped>
.input-wrapper {
  &, &.error {
    margin-top: 15px;
  }
}
</style>
